export default function BentoCheckIcon() {
    return (
        <svg viewBox="0 0 27 32" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.918 23.948 4.344 16.14c-.392-.464-.392-1.232 0-1.696l1.43-1.696c.392-.464 1.04-.464 1.432 0l4.428 5.248 9.504-11.248c.391-.464 1.04-.464 1.43 0L24 8.444c.391.464.391 1.232 0 1.696L12.363 23.948c-.392.464-1.04.464-1.431 0h-.014z" fill="#E42436"/>
        </svg>
    );
  }
  